import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';

export default action('removeMentionTuple')(function removeMentionTuple(
    viewState: AtMentionsViewState,
    atMentionId: string,
    targetRecipient: FindRecipientPersonaType
) {
    viewState.atMentionTuples[atMentionId] = targetRecipient;
});
